import React, {createContext} from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import AdminRouter from './pages/admin';
import Inout from './pages/admin/inout';
import UserRouter from "./pages/user";
import Gate from './pages/user/gate';
import VisitQRCode from './pages/user/visit/qrcode';
import InoutView from './pages/admin/inout-view';

function App() {
  return (
      <Router>
        <Switch>
            <Route path={"/qrcode/:visitInfoSeq"} component={VisitQRCode} />
            <Route path="/in-out/:visitorInfoSeq/view" exact component={InoutView} />
            <Route path="/in-out/:visitorInfoSeq" exact component={Inout} />
            <Route path="/admin" render={(props) => <AdminRouter {...props}/> } />
            <Route path="/visit" render={(props) => <UserRouter {...props} />}/>
            <Route path="/" exact component={Gate}/>
        </Switch>
      </Router>
  );
}

export default App;
